module.exports = "/images/DISGUST.png?7b375f5f651da1c5c14beb6c676f91c1";